/**
 * Values for Sample History
 */
export enum SampleHistory {
  NaturalState = 'NaturalState',
  AirDried = 'AirDried',
  OvenDried = 'OvenDried',
  Unknown = 'Unknown',
}

/**
 * Values for Timing Method
 */
export enum TimingMethod {
  ClockOrWatch = 'ClockOrWatch',
  CalibratedTimer = 'CalibratedTimer',
}

/**
 * Values for Water Used
 */
export enum WaterUsed {
  DistilledWater = 'DistilledWater',
  Other = 'Other',
}

/**
 * Values for Slacking occurred
 */
export enum Slaking {
  Within10Min = 'Within10Min',
  Within2Hours = 'Within2Hours',
  No = 'No',
}

/**
 * Values for Swelling
 */
export enum Swelling {
  SwellingOccurred = 'SwellingOccurred',
  SwellingDidNotOccur = 'SwellingDidNotOccur',
}

/**
 * Values for Amount of Dispersion
 */
export enum DispersionAmount {
  Extreme = 'Extreme',
  Strong = 'Strong',
  Moderate = 'Moderate',
  Slight = 'Slight',
  None = 'None',
}

/**
 * Values for Re-moulded Dispersion
 */
export enum DispersionRemould {
  Extreme = 'Extreme',
  Strong = 'Strong',
  Moderate = 'Moderate',
  Slight = 'Slight',
  NotRecorded = 'NotRecorded',
}

/**
 * Values for Calcite
 */
export enum Calcite {
  Present = 'Present',
  NotPresent = 'NotPresent',
}

/**
 * Values for Gypsum
 */
export enum Gypsum {
  Present = 'Present',
  NotPresent = 'NotPresent',
}

/**
 * Values for After resting for 10 minutes
 */
export enum After10Min {
  SuspensionRemainsDispersed = 'SuspensionRemainsDispersed',
  FlocculationOccurred = 'FlocculationOccurred',
}